// extracted by mini-css-extract-plugin
module.exports = {"SKCard":"styles_SKCard__5YCPj","reverse":"styles_reverse__18Q5B"};